import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { bonusSchema } from '../types';

export const createDeleteBonusMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/bonus/${id}`,
			body: () => ({}),
		},
		response: {
			contract: zodContract(bonusSchema),
		},
	});
